// @ts-ignore
import * as React from 'react';
import TextInput from '@af-common/Common/_components/TextInput';

export type Props = {
	moduleId?: string
	x?: number
	y?: number
	onXChange?: Function
	onYChange?: Function
}

export default class ModulePosition extends React.Component<Props> {
	render = () => <div style={ {display: 'none'} }>
		<TextInput useUnits step={5} type="number" label={'X'} onChange={this.props.onXChange} value={String(this.props.x)}/>
		<TextInput useUnits step={5} type="number" label={'Y'} onChange={this.props.onYChange} value={String(this.props.y)}/>
	</div>
}